// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5bba38ed","483":"1cad3c9a","703":"d61f4bb4"}[chunkId] + ".chunk.js";
};